import { useToast } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useUpdateInvitedUserListQuery } from "@/queries/query-user-invited";

export type ResendUserInviteArgs = {
  invitationId: string;
};

export function useResendInvite() {
  const toast = useToast();
  const intl = useIntl();
  const updateInvitedUserListQuery = useUpdateInvitedUserListQuery();

  return useMutationWithErrorHandler(async ({ invitationId }: ResendUserInviteArgs) => {
    const result = await getRanaApiV1().InvitationsApi.invitationSendEmail({
      invitationId,
    });

    updateInvitedUserListQuery(result.id, result);

    toast({
      title: intl.formatMessage({
        id: "success",
        defaultMessage: "Success!",
      }),
      description: intl.formatMessage({
        id: "success.resend_invite",
        defaultMessage: "Successfully resent invite.",
      }),
    });
  });
}
